module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-11.e8c75520.JPG";